import React from 'react';
import { Spinner } from 'react-bootstrap';

const KontrimanLoader = ({ size = "lg", message = "Loading..." }) => {
  return (
    <div
      className="d-flex flex-column align-items-center justify-content-center"
      style={{
        position: 'fixed',
        top: 0,
        left: 0,
        right: 0,
        bottom: 0,
        backgroundColor: '#2e3457', 
        zIndex: 9999,
        pointerEvents: 'none', 
      }}
    >
      <Spinner animation="border" role="status" variant="white" size={size}>
        <span className="visually-hidden">{message}</span>
      </Spinner>
      <small className="mt-2 text-white">{message}</small>
    </div>
  );
};

export default KontrimanLoader;
